import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import NProgress from "nprogress";


export const GetDailyWagesAttendanceDataHelper = async (params) => {
     NProgress.start()
    return await axiosInstance(`/finance/getDailyWagesAttendanceData`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            month: params?.month,
            year: params?.year,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Data retrived successfully", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Unable to retrived data", hasError: false, data: err?.response?.data }
        })
} 

export const UpdateDailyWagesAttendanceDataHelpesr = async (params) => {
    return await axiosInstance(`/finance/updateDailyWagesAttendanceData`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            month: params?.month,
            year: params?.year,
            user_id: getUserId(),
            total_seconds: params?.total_seconds,
            employee_fk: params?.employee_fk
        }
    })
        .then((res) => {
            return { message: "Updated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update Template", hasError: false, data: err?.response?.data }
        })
}